<template>
    <div class="table-text-center">{{ message }}
        <template v-if="!filtersEmpty">
            &nbsp;
            <a @click="$emit('clearFilters')">{{ t_clear_filters }}</a>
            <template v-if="!allFilterableColumnsSelected">
                &nbsp;
                {{ t_or }}
                &nbsp;
                {{ t_select_more_columns }}</template>
        </template>
    </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        message: {
            type: String,
            required: true
        },
        filtersEmpty: {
            type: Boolean,
            required: true
        },
        allFilterableColumnsSelected: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            t_or: Lang.langGet('or'),
            t_clear_filters: Lang.langGet('Clear filters'),
            t_select_more_columns: Lang.langGet('Select more columns')
        }
    }
})
</script>
